import React from "react";
import { Clock, MessageCircle } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function TransformeSeuSorrisoHoje() {
  return <section data-section-id="193791" id="garanta-seu-lugar-no-próximo-grupo" className="text-white py-12 px-6 !bg-[rgba(19,118,123,1)] md:py-16">
      <div className="mx-auto max-w-4xl flex flex-col items-center text-center">
        <Badge variant="secondary" className="mb-8 rounded-full border-none bg-black/10 px-4 py-1.5 text-sm font-default text-white hover:bg-black/15">
          <Clock className="mr-2 size-4" />
          Vagas Limitadas para Grupos Exclusivos
        </Badge>

        <h2 className="mb-6 text-4xl font-default font-bold tracking-tight text-white md:text-5xl lg:text-6xl">
          Sua próxima grande história começa aqui
        </h2>

        <p className="mb-10 max-w-2xl text-lg font-default text-white md:text-xl">
          Nossos grupos exclusivos para 2026 e 2027 já estão com as últimas vagas. Não perca a chance de viajar com total conforto, segurança e o suporte da KG Viagens.
        </p>

        <div className="flex flex-col items-center gap-4">
          <Button size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive has-[>svg]:px-4 h-auto rounded-full px-8 py-6 text-lg font-default font-bold text-primary-foreground shadow-lg shadow-primary/20 transition-transform disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:!bg-[#8E460B] hover:scale-105 !bg-[#B35900]" asChild>
            <Link to="https://wa.me/5548988221618" newTab>
              <MessageCircle className="mr-2 size-6" />
              Falar no WhatsApp
            </Link>
          </Button>

          <div className="flex items-center gap-2 text-sm font-default font-medium text-white">
            <Clock className="size-4" />
            <span>Fale diretamente com nossa equipe em Florianópolis</span>
          </div>
        </div>
      </div>
    </section>;
}